import styled from "styled-components";
import { Color, Font } from "@styles/constants";

export const TotalWrapper = styled.div<{ shadow?: boolean }>`
  padding: 16px 16px;
  font-size: 14px;
  margin-bottom: 0;
  display: flex;
  flex-direction: column;
  box-shadow: ${(props) => (props.shadow ? "0 -7px 15px 0px rgb(0 0 0 / 20%)" : "none")};
`;

export const TotalHeader = styled.div`
  line-height: 20px;
  width: 100%;
  font-size: 16px;
  font-family: ${Font.semibold};
  display: flex;
  justify-content: space-between;
`;

export const DescriptionWrapper = styled.div`
  font-size: 14px;
  color: ${Color.red10};
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
`;
